<template>
  <div class="item">
    <div class="status-bar">
      <div class="status-bar__back-button">
        <vs-button
          icon="arrow_back"
          class
          type="flat"
          color="dark"
          to="/items"
          title="back to supplies's list"
        ></vs-button>
      </div>
      <h2 class="status-bar__title">
        {{ item.name }}
      </h2>
      <div class="status-bar__count">
        <vs-icon icon="ballot"></vs-icon>
        <span class="label">Current count:</span>
        <span>
          {{ item.total_count }}
        </span>
        <span
          v-if="item.min_count"
          class="outcome-reason markdown"
          :class="{
            danger: item.total_count < item.min_count,
            grey: item.total_count >= item.min_count,
          }"
        >
          <vs-icon icon="arrow_forward" size="18px"></vs-icon>
          Minimum: {{ item.min_count }}
        </span>
        <span
          class="is-min-quantity-notify markdown "
          :title="item.is_min_quantity_notify ? 'Alert is ON' : 'Alert is off'"
          :class="{
            danger: item.is_min_quantity_notify,
            grey: !item.is_min_quantity_notify,
          }"
        >
          <vs-icon
            icon="notifications"
            size="18px"
          ></vs-icon>
        </span>
      </div>
      <div class="status-bar__amount" v-if="item.total_price">
        <vs-icon icon="wallet"></vs-icon>
        <span class="label">Total cost:</span>
        {{ item.total_price }} <span class="amount__currency">₽</span>
      </div>
      <div class="status-bar__manage-buttons">
        <vs-button
          icon="edit"
          class="status-bar__edit-button"
          type="flat"
          color="dark"
          @click="popupActive = true"
          >Edit</vs-button
        >
      </div>
    </div>
    <div class="view-content">
      <Split>
        <SplitArea :size="75" class="item-split-block">
          <div class="item__data">
            <div class="item__info">
              <div class="item__info__desc" v-if="item.desc">
                <div class="label">Description:</div>
                {{ item.desc }}
              </div>
              <div class="item__info__dates">
                <div class="item__info__created">
                  <vs-icon icon="more_time"></vs-icon>
                  <span class="label">Created:</span>
                  {{ $moment(item.created * 1000).format('YYYY-MM-DD HH:mm') }}
                </div>
                <div class="item__info__updated">
                  <vs-icon icon="edit_calendar"></vs-icon>
                  <span class="label">Updated:</span>
                  {{ $moment(item.updated * 1000).format('YYYY-MM-DD HH:mm') }}
                </div>
                <div class="item__info__owner">
                  <span class="label">Owner:</span>
                  <teacher :teacher="item.owner" size="18px">
                    {{ item.owner.nickname }}
                  </teacher>
                </div>
              </div>
              <div class="item__transactions">
                <vs-table
                  stripe
                  v-model="item.transactions"
                  :data="item.transactions"
                  search
                  class="item__transactions__table"
                >
                  <template slot="header">
                    <div class="item__transactions__header">
                      <h3>Transactions ({{ item.transactions.length }})</h3>
                      <vs-button
                        icon="add"
                        type="flat"
                        @click="popupInFormActive = true"
                        size="small"
                        >Add in</vs-button
                      >
                      <vs-button
                        icon="remove"
                        type="flat"
                        color="danger"
                        @click="popupOutFormActive = true"
                        size="small"
                        >Add out</vs-button
                      >
                      <vs-button
                        icon="splitscreen"
                        type="flat"
                        @click="popupInventoryFormActive = true"
                        size="small"
                        >Inventory</vs-button
                      >
                    </div>
                    <!-- <div class="items__filter">
                      <div class="label">Status</div>
                      <vs-select
                        v-model="selfStatus"
                        @change="updateStatusHandler"
                      >
                        <vs-select-item value="0" text="Deactivated" />
                        <vs-select-item value="1" text="Active" />
                      </vs-select>
                    </div> -->
                  </template>
                  <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th sort-key="count">Amount</vs-th>
                    <vs-th sort-key="count">Price per unit</vs-th>
                    <vs-th sort-key="price">Cost</vs-th>
                    <vs-th sort-key="created">Date</vs-th>
                    <vs-th>User</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :data="tr"
                      :key="tr.id"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td :data="data[indextr].transaction_type">
                        <vs-icon
                          icon="add"
                          v-if="data[indextr].transaction_type == 1"
                          color="success"
                        ></vs-icon>
                        <vs-icon
                          icon="remove"
                          v-if="data[indextr].transaction_type == 2"
                          color="danger"
                        ></vs-icon>
                        <vs-icon
                          icon="splitscreen"
                          v-if="data[indextr].transaction_type == 3"
                          color="primary"
                        ></vs-icon>
                      </vs-td>
                      <vs-td :data="data[indextr].count" class="td-count">
                        <span class="count">{{ tr.count }}</span>
                        <span
                          v-if="
                            data[indextr].transaction_type == 2 &&
                            data[indextr].outcome_reason
                          "
                          class="outcome-reason markdown small warning"
                        >
                          {{
                            outcomeReasonsList.find(
                              (r) => r.id == data[indextr].outcome_reason
                            ).name
                          }}
                        </span>
                      </vs-td>
                      <vs-td :data="data[indextr].price_per_unit">
                        <span v-if="data[indextr].price_per_unit">
                          {{ tr.price_per_unit }} ₽
                        </span>
                      </vs-td>
                      <vs-td :data="data[indextr].price">
                        <span v-if="data[indextr].price">
                          {{ tr.price }} ₽
                        </span>
                      </vs-td>
                      <vs-td>
                        <span v-if="data[indextr].purchased">{{
                          $moment(data[indextr].purchased * 1000).format(
                            'YYYY-MM-DD'
                          )
                        }}</span>
                      </vs-td>
                      <vs-td>
                        <teacher :teacher="data[indextr].owner" size="18px">
                          {{ data[indextr].owner.nickname }}
                        </teacher>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="item__gallery">
              <div
                class="item__gallery__main-img"
                v-if="mainImage"
                @click="showInViewerHandler(mainImage.id)"
              >
                <img class="item-thumb" :src="proxy + mainImage.file_path" />
              </div>
              <div v-else class="default-image">
                <vs-icon icon="image"></vs-icon>
              </div>
              <div class="gallery" v-if="item.files && item.files.length > 1">
                <img
                  :key="image.id"
                  :src="`${proxy}${image.thumb_path}?i=${index}`"
                  v-for="(image, index) in item.files"
                  @click="showAsMainImageHandler(image)"
                />
              </div>
            </div>
          </div>
        </SplitArea>
        <SplitArea :size="25">
          <vs-tabs>
            <vs-tab label="Comments">
              <div class="con-tab-ejemplo">
                <Comments :itemId="$route.params.item_id" itemType="Items" />
              </div>
            </vs-tab>
          </vs-tabs>
        </SplitArea>
      </Split>
    </div>
    <vs-popup
      class="form-popup teachers__popup"
      classContent="teachers__popup-content"
      title="Teacher"
      :active.sync="popupActive"
    >
      <ItemsForm v-if="popupActive" :item="item" @closePopup="closePopup" />
    </vs-popup>
    <vs-popup
      class="form-popup transactions__popup"
      classContent="transaction-out-form__popup-content"
      title="Out"
      :active.sync="popupOutFormActive"
    >
      <TransactionOutForm
        v-if="popupOutFormActive"
        :transaction="transaction"
        :itemId="item.id"
        @closePopup="closePopup"
      />
    </vs-popup>
    <vs-popup
      class="form-popup transactions__popup"
      classContent="transaction-in-form__popup-content"
      title="Out"
      :active.sync="popupInFormActive"
    >
      <TransactionInForm
        v-if="popupInFormActive"
        :transaction="transaction"
        :itemId="item.id"
        @closePopup="closePopup"
      />
    </vs-popup>
    <vs-popup
      class="form-popup transactions__popup"
      classContent="transaction-inventory-form__popup-content"
      title="Out"
      :active.sync="popupInventoryFormActive"
    >
      <TransactionInventoryForm
        v-if="popupInventoryFormActive"
        :transaction="transaction"
        :itemId="item.id"
        @closePopup="closePopup"
      />
    </vs-popup>
    <viewer :images="item.files" @inited="inited" class="viewer" ref="viewer">
      <img
        v-for="(src, index) in item.files"
        :src="proxy + src.file_path"
        :key="index"
      />
    </viewer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { component as Viewer } from 'v-viewer'
import ItemsForm from '@/components/items/itemsForm.vue'
import TransactionOutForm from '@/components/items/transactionOutForm.vue'
import TransactionInForm from '@/components/items/transactionInForm.vue'
import TransactionInventoryForm from '@/components/items/transactionInventoryForm.vue'
import Comments from '@/components/comments/comments.vue'
import Teacher from '@/components//common/elements/teacher.vue'

import OutcomeReasons from '@/components/common/dicts/outcomeReasons.js'

export default {
  name: 'ItemView',
  title: 'SE-supply',
  data() {
    return {
      popupActive: false,
      popupOutFormActive: false,
      popupInFormActive: false,
      popupInventoryFormActive: false,
      id: this.$route.params.item_id,
      loader: true,
      proxy: process.env.VUE_APP_PROXY,
      mainImage: null,
      outcomeReasonsList: OutcomeReasons,
    }
  },
  components: {
    ItemsForm,
    Comments,
    Viewer,
    TransactionOutForm,
    TransactionInForm,
    TransactionInventoryForm,
    Teacher,
  },
  computed: {
    ...mapState({
      item: (state) => state.items.singleItem,
      items: (state) => state.items.items,
      transactions: (state) => state.items.transactions,
    }),
  },
  methods: {
    closePopup: async function () {
      await this.getItem()
      this.popupActive = false
      this.popupOutFormActive = false
      this.popupInFormActive = false
      this.popupInventoryFormActive = false
    },
    getItem: async function () {
      await this.$store
        .dispatch('items/getSingleItemAction', {
          id: this.$route.params.item_id,
        })
        .then(() => {})
    },

    showAsMainImageHandler: function (image) {
      this.mainImage = image
    },
    showInViewerHandler: function (fileId) {
      const fileIndex = this.item.files.findIndex((f) => f.id == fileId)
      if (fileIndex != -1) this.$viewer.view(fileIndex)
    },
    inited(viewer) {
      this.$viewer = viewer
    },
  },
  created: async function () {
    await this.getItem()

    if (!this.items || !this.items.length) {
      await this.$store.dispatch('items/getItemsAction')
    }
    console.log(this.item.files)
    if (this.item.files) {
      this.mainImage = this.item.files[0]
    }
  },
}
</script>

<style lang="scss">
.schoolyears {
  margin-bottom: 15px;
}
// .teacher-table-split-block {
//   overflow-x: auto;
// }
.delimiter {
  width: 100%;
  height: 2px;
  background-color: #eee;
  margin: 20px 0;
}
.item {
  .status-bar {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    &__count,
    &__amount {
      margin-left: 2rem;
      font-weight: bold;
      font-size: 1.2rem;
    }
    .label {
      color: var(--sub-color);
      margin-left: 0.5rem;
      font-weight: normal;
      font-size: 1rem;
    }
    .amount__currency {
      font-size: 1rem;
    }
  }
  &__data {
    display: flex;
    flex-flow: row nowrap;
    gap: 2rem;
    padding: 1rem;
    .item__gallery {
      // flex: 0.5;
      width: 40%;
      &__main-img {
        display: flex;
        aspect-ratio: 1 / 1;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img {
          width: 100%;
          border: 1px solid var(--sub-color);
          border-radius: 10px;
        }
      }
      .default-image{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        i{
          font-size: 10rem;
          opacity: 0.2;
        }
      }
      .gallery {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 1rem;
        margin-top: 1rem;
        img {
          aspect-ratio: 1 / 1;
          height: 100%;
          width: 100%;
          border-radius: 10px;
          cursor: pointer;
          border: 1px solid var(--sub-color);
        }
      }
    }
  }
  &__info {
    display: flex;
    flex-flow: column nowrap;
    gap: 2rem;
    width: 60%;
    padding-top: 10px;
    &__desc {
      width: 100%;
      padding: 1rem;
      background-color: #f1f1f1;
      border-radius: 10px;
      .label {
        margin-bottom: 1rem;
        color: var(--sub-color);
        font-size: 0.9rem;
      }
    }
    &__dates {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      gap: 2rem;
      .item__info__created,
      .item__info__updated {
        .vs-icon {
          margin-right: 0.5rem;
        }
      }
      .label {
        font-size: 0.9rem;
        color: var(--sub-color);
      }
    }
    &__owner {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
  }
  &__transactions {
    &__header {
      display: flex;
      flex-flow: row nowrap;
      gap: 0.5rem;
      align-items: center;
      h3 {
        margin-right: 2rem;
      }
    }
    .td-count > span {
      display: flex;
      flex-flow: column nowrap;
      gap: 3px;
      .count {
        font-size: 1.2rem;
        font-weight: bold;
      }
      .outcome-reason {
        width: max-content;
        i {
          margin-top: -4px;
        }
      }
    }
  }
  .outcome-reason, .is-min-quantity-notify {
    width: max-content;
    i {
      margin-top: -4px;
    }
  }
}
</style>

